var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 48,
    viewBox: "0 0 45 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_89_239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.7751 22.7448C43.1176 26.1271 37.8867 29.8288 31.8788 30.5462C28.746 30.9201 25.6616 31.2636 22.3723 31.1128C16.9934 30.8663 12.7491 29.8287 12.7491 29.8287C12.7491 30.3525 12.7813 30.851 12.8459 31.3174C13.5453 36.6258 18.1096 36.9439 22.4333 37.0921C26.7975 37.2413 30.6834 36.0161 30.6834 36.0161L30.8626 39.9614C30.8626 39.9614 27.81 41.6006 22.3723 41.9021C19.3739 42.0667 15.6508 41.8267 11.3145 40.6788C1.90963 38.1894 0.291999 28.1644 0.0446417 17.9923C-0.0306868 14.9721 0.0157366 12.1242 0.0157366 9.74225C0.0157366 -0.659212 6.83086 -3.70809 6.83086 -3.70809C10.2672 -5.28631 16.1637 -5.9499 22.2935 -6H22.4442C28.574 -5.9499 34.4745 -5.28631 37.9105 -3.70809C37.9105 -3.70809 44.7253 -0.659212 44.7253 9.74242C44.7253 9.74242 44.8109 17.4166 43.7751 22.7448Z",
    fill: "#3088D4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.6871 10.5493V23.1439H31.6974V10.9195C31.6974 8.34254 30.613 7.03463 28.4443 7.03463C26.0465 7.03463 24.8448 8.58622 24.8448 11.6542V18.3453H19.8845V11.6542C19.8845 8.58622 18.6824 7.03463 16.2845 7.03463C14.1159 7.03463 13.0317 8.34254 13.0317 10.9195V23.1437H8.04199V10.5495C8.04199 7.97536 8.69735 5.92993 10.0138 4.41653C11.3715 2.9033 13.1493 2.12759 15.3562 2.12759C17.9095 2.12759 19.8432 3.10897 21.1216 5.07206L22.3646 7.15551L23.6077 5.07206C24.8858 3.10897 26.8195 2.12759 29.3731 2.12759C31.5799 2.12759 33.3576 2.9033 34.7155 4.41653C36.0316 5.92993 36.6871 7.97519 36.6871 10.5493Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.85,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetto);
export default __webpack_public_path__ + "static/media/metto.d67f40b196d51bd2e24999c2fc5aa714.svg";
export { ForwardRef as ReactComponent };